<template>
  <div>
    <!-- Header -->
    <!-- v-if="!isMobile" -->
    <v-toolbar 
      
      style="border-top-left-radius: 24px; background-image: linear-gradient(330deg, rgba(216,27,96,1), #eeff41);"
      color="secondary"
      dark
      flat>
      <v-toolbar-side-icon @click.stop="drawer = false">
        <v-icon>{{ isMobile ? 'fas fa-times' : 'fas fa-chevron-right' }}</v-icon>
      </v-toolbar-side-icon>
      <v-spacer></v-spacer>

      <div class="subheading text-xs-center">
        {{ filterText }}
      </div>

      <v-spacer></v-spacer>

      <v-btn 
        icon
        disabled>
        <v-icon>
        </v-icon>
      </v-btn>
    </v-toolbar>



    <v-toolbar 

      dense 
      flat>
      <v-btn 
        :color="selectedFilter === 'AppFilterOverview' ? 'pink accent-3' : 'grey'"
        small 
        flat
        @click="leftButton">
        <v-icon
          v-if="selectedFilter === 'AppFilterOverview'"
          class="mr-1"
          small>
          far fa-times-octagon
          <!-- TODO: Text/Translate -->
        </v-icon> {{ selectedFilter === 'AppFilterOverview' ? 'Reset Filter' : 'Zurück' }}
      </v-btn>
      
      <v-spacer></v-spacer>

      <!-- v-if="isFilterSet" -->
      <v-btn 
        color="green"
        small 
        flat
        @click.stop="clickFilterPosts">
        <v-icon
          class="mr-1"
          small>
          far fa-sliders-h
        </v-icon>
        <!-- TODO: Text/Translate -->

        Suchen
      </v-btn>
    </v-toolbar>

    
    <keep-alive>
      <v-list 
        v-if="selectedFilter === 'AppFilterOverview'"
        :dense="isMobile"
        :class="!isMobile ? 'mt-3' : ''"
        two-line 
        subheader>
        <!-- TODO: Text/Translate -->

        <v-list-tile
          avatar
          @click="setSelectedFilter({ selectedFilter: 'AppFilterSearch', filterText: 'Suche' })">
          <v-list-tile-avatar>
            <v-icon>fas fa-search</v-icon>
          </v-list-tile-avatar>

          <v-list-tile-content>
            <!-- TODO: Text/Translate -->

            <v-list-tile-title>Was suchst du?</v-list-tile-title>
            <v-list-tile-sub-title v-if="timelineFilter.searchFilter">
              {{ timelineFilter.searchFilter }}
            </v-list-tile-sub-title>
          </v-list-tile-content>

          <v-list-tile-action>
            <v-btn 
              icon 
              ripple>
              <v-icon color="grey lighten-1">
                fas fa-chevron-right
              </v-icon>
            </v-btn>
          </v-list-tile-action>
        </v-list-tile>





        <v-list-tile
          avatar
          @click="setSelectedFilter({ selectedFilter: 'AppFilterActivity', filterText: 'Activity' })">
          <v-list-tile-avatar>
            <v-icon>fas fa-credit-card</v-icon>
          </v-list-tile-avatar>

          <v-list-tile-content>
            <v-list-tile-title>
              Activity
            </v-list-tile-title>
            <v-list-tile-sub-title>{{ displayActivity }}</v-list-tile-sub-title>
          </v-list-tile-content>

          <v-list-tile-action>
            <v-btn 
              icon 
              ripple>
              <v-icon color="grey lighten-1">
                fas fa-chevron-right
              </v-icon>
            </v-btn>
          </v-list-tile-action>
        </v-list-tile>


        <v-list-tile
          avatar
          @click="setSelectedFilter({ selectedFilter: 'AppFilterLocation', filterText: 'Location' })">
          <v-list-tile-avatar>
            <v-icon>fas fa-map-marker-alt</v-icon>
          </v-list-tile-avatar>

          <v-list-tile-content>
            <v-list-tile-title>Ort</v-list-tile-title>
            <v-list-tile-sub-title>
              {{ timelineFilter.locationFilter }}
            </v-list-tile-sub-title>
            <v-list-tile-sub-title>
              <!-- TODO: Text/Translate -->

              Umkreis: {{ timelineFilter.distanceFilter }} km
            </v-list-tile-sub-title>
          </v-list-tile-content>

          <v-list-tile-action>
            <v-btn 
              icon 
              ripple>
              <v-icon color="grey lighten-1">
                fas fa-chevron-right
              </v-icon>
            </v-btn>
          </v-list-tile-action>
        </v-list-tile>


        <!-- <v-list-tile
          avatar
          @click="setSelectedFilter({ selectedFilter: 'AppFilterLocation', filterText: 'Location' })">
          <v-list-tile-avatar>
            <v-icon>fas fa-route</v-icon>
          </v-list-tile-avatar>

          <v-list-tile-content>
            <v-list-tile-title>Umkreis</v-list-tile-title>
            <v-list-tile-sub-title>{{ timelineFilter.distanceFilter }}</v-list-tile-sub-title>
          </v-list-tile-content>

          <v-list-tile-action>
            <v-btn 
              icon 
              ripple>
              <v-icon color="grey lighten-1">
                fas fa-chevron-right
              </v-icon>
            </v-btn>
          </v-list-tile-action>
        </v-list-tile> -->


        <!-- TODO: Text/Translate -->

        <v-list-tile
          avatar
          @click="setSelectedFilter({ selectedFilter: 'AppFilterDate', filterText: 'Datum' })">
          <v-list-tile-avatar>
            <v-icon>fas fa-calendar-alt</v-icon>
          </v-list-tile-avatar>

          <v-list-tile-content>
            <!-- TODO: Text/Translate -->

            <v-list-tile-title>Datum</v-list-tile-title>
            <v-list-tile-sub-title>{{ timelineFilter.dateFilter !== '' ? timelineFilter.dateFilter : new Date().toISOString().substr(0, 10) | dateLong }}</v-list-tile-sub-title>
          </v-list-tile-content>

          <v-list-tile-action>
            <v-btn 
              icon 
              ripple>
              <v-icon color="grey lighten-1">
                fas fa-chevron-right
              </v-icon>
            </v-btn>
          </v-list-tile-action>
        </v-list-tile>


        <v-list-tile
          avatar
          @click="setSelectedFilter({ selectedFilter: 'AppFilterCategories', filterText: 'Kategorien' })">
          <v-list-tile-avatar>
            <v-icon>fas fa-star</v-icon>
          </v-list-tile-avatar>

          <v-list-tile-content>
            <!-- TODO: Text/Translate -->

            <v-list-tile-title>Kategorien</v-list-tile-title>
            <v-list-tile-sub-title>{{ displayCategories }}</v-list-tile-sub-title>
          </v-list-tile-content>

          <v-list-tile-action>
            <v-btn 
              icon 
              ripple>
              <v-icon color="grey lighten-1">
                fas fa-chevron-right
              </v-icon>
            </v-btn>
          </v-list-tile-action>
        </v-list-tile>

        <!-- <v-list-tile
          avatar
          @click="setSelectedFilter({ selectedFilter: 'AppFilterCategories', filterText: 'Reihenfolge' })">
          <v-list-tile-avatar>
            <v-icon>fas fa-sort-amount-down</v-icon>
          </v-list-tile-avatar>

          <v-list-tile-content>
            <v-list-tile-title>Reihenfolge</v-list-tile-title>
            <v-list-tile-sub-title>Neueste Zuerst / Zetilich</v-list-tile-sub-title>
          </v-list-tile-content>

          <v-list-tile-action>
            <v-btn 
              icon 
              ripple>
              <v-icon color="grey lighten-1">
                fas fa-chevron-right
              </v-icon>
            </v-btn>
          </v-list-tile-action>
        </v-list-tile> -->



        <v-layout
          class="mb-5"
          row
          wrap
          align-center
          justify-space-around>
          <v-flex
            v-if="!isFilterEqual"
            xs6
            class="mt-3 text-xs-center">
            <v-btn 
              fab
              small
              :dark="loading"
              :color="loading ? 'green' : 'secondary'"
              @click="saveFilter(timelineFilter)">
              <v-icon>{{ loading ? 'fas fa-check' : 'fas fa-save' }}</v-icon>
            </v-btn>
            <div class="caption grey--text">
              <!-- TODO: Text/Translate -->

              Filter als Standard speichern?
            </div>
          </v-flex>

          <v-flex
            v-if="!isFilterEqual"

            xs6
            class="mt-3 text-xs-center">
            <v-btn 
              fab
              :loading="loading"
              small
              :dark="loading"
              :color="loading ? 'green' : 'secondary'"
              @click="clickLoadFilter">
              <v-icon>fas fa-cloud-download</v-icon>
            </v-btn>
            <div class="caption grey--text">
              <!-- TODO: Text/Translate -->

              Standard Filter laden
            </div>
          </v-flex>
          <v-flex
            v-if="isFilterEqual"

            xs12
            class="mt-3 text-xs-center">
            <v-btn 
              fab
              :loading="loading"
              small
              :ripple="false"
              :dark="loading"
              :color="loading ? 'green' : 'secondary'">
              <v-icon>
                fas fa-check
              </v-icon>
            </v-btn>
            <div class="caption grey--text">
              <!-- TODO: Text/Translate -->

              Standard Filter
            </div>
          </v-flex>
          <!-- <v-flex
            xs6
            class="mt-3 text-xs-center">
            <v-btn 
              @click="toConsole(timelineFilter)">
              TimelineFilter
            </v-btn>
          </v-flex>
          <v-flex
            xs6
            class="mt-3 text-xs-center">
            <v-btn 
              
              @click="toConsole(timelineResetFilter)">
              StandardFilter
            </v-btn>
          </v-flex> -->
        </v-layout>
        <!-- isFilterSet? {{ isFilterSet }} -->
      </v-list>

      <component
        :is="selectedFilter"
        v-else></component>
    </keep-alive>
  </div> 
</template>
    

<script>
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex'
import { isEqual } from 'lodash'

// import FilterOverview     from '@/components/global_comps/Filter/Overview_Filter'
import FilterSearch       from '@/components/global_comps/Filter/Filter_Search'
import FilterActivity        from '@/components/global_comps/Filter/Filter_Activity'
import FilterLocation     from '@/components/global_comps/Filter/Filter_Location'
import FilterDate         from '@/components/global_comps/Filter/Filter_Date'
import FilterCategories   from '@/components/global_comps/Filter/Filter_Categories'

export default {
  components: {
    // eslint-disable-next-line
    AppFilterSearch: FilterSearch,
    // eslint-disable-next-line
    AppFilterActivity: FilterActivity,
    // eslint-disable-next-line
    AppFilterLocation: FilterLocation,
    // eslint-disable-next-line
    AppFilterDate: FilterDate,
    // eslint-disable-next-line
    AppFilterCategories: FilterCategories
  },
  data() {
    return {
    }
  },

  computed: {
    ...mapState({
      user: state => state.user.user,
      timelineFilter: state => state.timeline.timelineFilter,
      timelineResetFilter: state => state.timeline.timelineResetFilter,
      timelineStandardFilter: state => state.timeline.timelineStandardFilter,
      isMobile: state => state.isMobile,
      selectedFilter: state => state.timeline.timelineFilter.selectedFilter,
      filterText: state => state.timeline.timelineFilter.filterText,
      filter_timelinedrawer: state => state.timeline.timelineFilter.filter_timelinedrawer,
      categories: state => state.categories,
    }),
    ...mapGetters({
      loading: 'loading',
    }),
   
    isFilterEqual() {
      let JSONCoordinatesTimelineFilter = JSON.parse(JSON.stringify(this.timelineFilter.coordinatesFilter))
      let JSONCoordinatesStandardFilter = JSON.parse(JSON.stringify(this.timelineStandardFilter.coordinatesFilter))

      let coordsTLF = { lat: (JSONCoordinatesTimelineFilter.lat).toFixed(3), lng: (JSONCoordinatesTimelineFilter.lng).toFixed(3) }
      let coordsTLSF = { lat: (JSONCoordinatesStandardFilter.lat).toFixed(3), lng: (JSONCoordinatesStandardFilter.lng).toFixed(3) }

      let activityDiff = isEqual(this.timelineFilter.activityFilter.concat().sort(), this.timelineStandardFilter.activityFilter.concat().sort())
      let categoriesDiff = isEqual(this.timelineFilter.categoriesFilter.concat().sort(), this.timelineStandardFilter.categoriesFilter.concat().sort())
      let coordinatesDiff = isEqual(coordsTLF, coordsTLSF)
      let distanceDiff = this.timelineFilter.distanceFilter === this.timelineStandardFilter.distanceFilter
      let locationDiff = isEqual(this.timelineFilter.locationFilter, this.timelineStandardFilter.locationFilter)
      return activityDiff && categoriesDiff  && distanceDiff && locationDiff && coordinatesDiff
    },

    isFilterSet() {
      let coordsTLF = { lat: (this.timelineFilter.coordinatesFilter.lat).toFixed(3), lng: (this.timelineFilter.coordinatesFilter.lng).toFixed(3) }
      let coordsTLRF = { lat: (this.timelineResetFilter.coordinatesFilter.lat).toFixed(3), lng: (this.timelineResetFilter.coordinatesFilter.lng).toFixed(3) }

      let allCategoriesAry = []
      for (const key of Object.keys(this.categories)) {
        allCategoriesAry.push(key)
      }

      let searchSet = this.timelineFilter.searchFilter !== ''
      let activitySet = !(isEqual(this.timelineFilter.activityFilter.concat().sort(), this.timelineResetFilter.activityFilter.concat().sort()))
      let categoriesSet = this.timelineFilter.categoriesFilter.length !== 0 && this.timelineFilter.categoriesFilter.length !== allCategoriesAry.length
      let coordinatesSet = !(isEqual(coordsTLF, coordsTLRF))
      let distanceSet = this.timelineFilter.distanceFilter !== this.timelineResetFilter.distanceFilter
      // let locationSet = !(isEqual(this.timelineFilter.locationFilter, this.timelineResetFilter.locationFilter))
      let dateSet = this.timelineFilter.dateFilter !== new Date().toISOString().substr(0, 10)
       
      return searchSet || activitySet || categoriesSet || dateSet || distanceSet || coordinatesSet
     
    },

    displayActivity() {
      if (this.timelineFilter.activityFilter.length === 2) {
        return this.renameActivity(this.timelineFilter.activityFilter[0]) + ', ' + this.renameActivity(this.timelineFilter.activityFilter[1])
      } else if (this.timelineFilter.activityFilter.length ===1 ){
        return this.renameActivity(this.timelineFilter.activityFilter[0])
      } else {
        return 'Alle'
      }
    },


    displayCategories() {
      let selectedCats = this.timelineFilter.categoriesFilter
      let allCategoriesAry = []
      for (const key of Object.keys(this.categories)) {
        allCategoriesAry.push(key)
      }
     
      if (selectedCats.length === allCategoriesAry.length || selectedCats.length === 0) {
        return 'Alle'
      } else if (selectedCats.length === 3 ){
        return selectedCats[0] + ', ' + selectedCats[1] + ', ' + selectedCats[2]
      } else if (selectedCats.length === 2 ){
        return selectedCats[0] + ', ' + selectedCats[1]
      } else if (selectedCats.length === 1 ){
        return selectedCats[0]
      } else {
        return selectedCats[0] + ', ' + selectedCats[1] + ', ' + selectedCats[2] + ', + ' + (selectedCats.length - 3)
      }
    },

    drawer: {
      get() {
        return this.filter_timelinedrawer
      },
      set(value) {
        if (this.filter_timelinedrawer !== value) {
          this.clicktimelinedrawer(value)
        }
      }
    }
  },
 
  methods: {
    ...mapMutations([
      'setSelectedFilter',
      'clicktimelinedrawer',
      'setFilter',
    ]),
    ...mapActions([
      'filterPosts',
      'saveFilter',
      'loadFilter',
      'resetFilter'
    ]),
    
    toConsole(val) {
      console.log(val)
    },
    // <!-- TODO: Text/Translate -->

    renameActivity(activityname) {
      if (activityname === 'events') {
        return 'Events'
      } 
      if (activityname === 'moments') {
        return 'Moments'
      } 
      if (activityname === 'eventsbyfriends') {
        return 'Events by Friends'
      } 
    },

    clickLoadFilter() {
      this.loadFilter(this.timelineStandardFilter)
      this.drawer = false

    },
    

    clickFilterPosts() {
      // let filterOptions = { timelineFilter: this.timelineFilter, timelineResetFilter: this.timelineResetFilter, isFilterSet: this.isFilterSet }
      this.drawer = false
      this.$vuetify.goTo(0, {
        duration: 500,
        offset: 0,
        easing: 'easeInOutQuint'
      })
      if (this.isFilterSet) {
        this.filterPosts({isFilterSet: this.isFilterSet})
      } else {
        this.resetFilter()
      }
    },

    leftButton() {
      if (this.selectedFilter === 'AppFilterOverview') {
        this.drawer = false
        this.resetFilter()

        this.$vuetify.goTo(0, {
          duration: 500,
          offset: 0,
          easing: 'easeInOutQuint'
        })
        
      } else {
        // <!-- TODO: Text/Translate -->

        this.setSelectedFilter({ selectedFilter: 'AppFilterOverview', filterText: 'Filter anpassen' })
      }
    }
  }
}
</script>
